import SliderManager from "../../services/slider/sliderManager";

$('[data-action="scroll-to-activity-reviews"]').on('click', () => {
    let reviewsContainer = document.querySelector('[data-complement-info="complement_info"] [data-entity="reviews"]');
    if ($(reviewsContainer).find('user-review').length > 0) {
        reviewsContainer.scrollIntoView({'behavior': 'smooth'});
    }
});

let complementId = $('[data-complement-id]').data('complementId');

$('[data-complement-info]').ready(function () {
    self.sliderManager = new SliderManager();
    self.sliderManager.addSlider('[data-gallery="activity-' + complementId + '"]', null, 'bullets', 10);
});
